import { topUpDialogReducer as topUpDialogReducer } from '../top-up-dialog/redux/reducer';
import { createRequestReducer, createRequestReducerWithPreload, } from 'shared/hooks/redux/hooks';
import { combineReducers } from 'redux';
function billingType(preload) {
    //default need for mapframe
    return (state = preload.billing.billing_type ?? {}, action) => {
        switch (action.type) {
            default:
                return state;
        }
    };
}
function billingPrices(preload) {
    return (state = preload.prices ?? {}, action) => {
        switch (action.type) {
            default:
                return state;
        }
    };
}
export const billingReducer = (preload
// ): Reducer<CombinedState<BillingReduxState>, TopUpDialogActions> =>
) => combineReducers(
/*<
BillingReduxState,
TopUpDialogActions | RequestActions<BillingState, 'BILLING_STATE'>
>*/ {
    type: billingType(preload),
    prices: billingPrices(preload),
    state: createRequestReducerWithPreload('BILLING_STATE', preload.billing.billing_state, 'Ошибка обновления баланса'),
    settings: createRequestReducerWithPreload('BILLING_SETTINGS', preload.billing.billing_settings, 'Ошибка обновления настроек баланса'),
    h2000plus_firmware: createRequestReducer('BUY_H2000PLUS_FIRMWARE'),
    topup_dialog: topUpDialogReducer,
    pay: createRequestReducer('PAY'),
});
